import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { CategoryState } from "./types";

const initialState: CategoryState = {
  selectedCategoryId: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      state.selectedCategoryId = action.payload;
    },
    clearSelectedCategory: (state) => {
      state.selectedCategoryId = null;
    },
  },
});

export const { setSelectedCategory, clearSelectedCategory } =
  categorySlice.actions;

export default categorySlice.reducer;
